import { motion } from 'framer-motion'
import { HeroSection } from '../sections/home/HeroSection'
import { WhoWeAre } from '../sections/home/WhoWeAre'
import { OurImpact } from '../sections/home/OurImpact'
import { WhatWeDo } from '../sections/home/WhatWeDo'
import { BLSMethod } from '../sections/BLSMethod'
import { WhyChooseUs } from '../sections/home/WhyChooseUs'
import { OurClients } from '../sections/home/OurClients'
import { Team } from '../sections/Team'
import { InsightsPreview } from '../sections/home/InsightsPreview'
import { CTASection } from '../sections/home/CTASection'

export default function HomePage() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
      <HeroSection />
      <WhoWeAre />
      <OurImpact />
      <WhatWeDo />
      <BLSMethod />
      <WhyChooseUs />
      <OurClients />
      <Team variant="home" />
      <InsightsPreview />
      <CTASection />
    </motion.div>
  )
}
